module.exports = __webpack_public_path__ + "img/3_6.5d76d150.png";